<template>
  <a-config-provider :locale="locale">
    <div class="layout wh100 flex-column over-hidden">
      <!-- 头部 -->
      <div
        class="header w100 flex-row-end-between"
        v-if="route.path !== '/login'"
      >
        <div
          class="left flex-row-end-start pl20"
          v-if="route.path !== '/dashboard'"
        >
          <i class="iconfont icon-zuo arrow" @click="router.back()"></i>
          <!-- <LocaleSwitch class="pl20"/> -->
        </div>
        <div class="left flex-row-end-start pl20" v-else>
          <!-- <LocaleSwitch /> -->
          <!-- <img src="@/assets/images/weather.png" alt="" />
          <i>多云</i>
          <span>32</span>
          <em class="mb10">℃</em>
          <div class="flex-center">优26</div> -->
        </div>

        <div class="mid h100 flex-row-start-center pt20">
          <h2 class="head-text" :class="{ fr: currentLocale !== 'zh-CN' }">
            {{ t("app.title") }}
          </h2>
        </div>
        <div class="right flex-row-center-end pr20">
          <img
            v-for="menu in filteredMenus"
            :key="menu.name"
            :src="menu.icon"
            alt=""
            :title="menu.title"
            class="mr10"
            @click="handleMenuClick(menu)"
          />
          <img
            src="@/assets/images/logout.svg"
            alt=""
            :title="t('nav.logout')"
            class="mr10"
            @click="handleLogout"
          />
        </div>
      </div>
      <!-- 主体 -->
      <div class="container w100 over-hidden">
        <router-view></router-view>
      </div>
      <!-- 告警弹窗 -->
      <AlarmBox></AlarmBox>
      <AcPointAlarmBox></AcPointAlarmBox>
    </div>
  </a-config-provider>
</template>

<script>
import {
  defineAsyncComponent,
  defineComponent,
  onBeforeMount,
  onUnmounted,
  ref,
  watch,
  computed,
} from "vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import enUS from "ant-design-vue/es/locale/en_US";
import frFR from "ant-design-vue/es/locale/fr_FR";
import { currentLocale, t } from "@/utils/i18n";
import { queryDbData } from "@/api/common";
import { logout } from "@/api/user";
import { disconnectSocket } from "@/api/socket";
import commonMixin from "@/mixins/common";
import moment from "moment";

// 导入菜单图标
const homeIcon = require("@/assets/images/home.svg");
const graphIcon = require("@/assets/images/graph.svg");
const deviceIcon = require("@/assets/images/device.svg");
const alarmIcon = require("@/assets/images/alarm.svg");
const userIcon = require("@/assets/images/user.svg");
const protocolIcon = require("@/assets/images/protocol.svg");

const AlarmBox = defineAsyncComponent(() =>
  import("./components/AlarmBox.vue")
);
const AcPointAlarmBox = defineAsyncComponent(() =>
  import("./components/AcPointAlarmBox.vue")
);

export default defineComponent({
  // 已启用类型推断
  name: "Root",
  components: {
    AlarmBox,
    AcPointAlarmBox,
  },
  setup() {
    const locale = ref(zhCN);
    const mapAntdLocale = { "zh-CN": zhCN, "en-US": enUS, "fr-FR": frFR };
    watch(
      () => currentLocale.value,
      (lang) => {
        locale.value = mapAntdLocale[lang] || zhCN;
      },
      { immediate: true }
    );
    let { route, router, store } = commonMixin();

    const currentUser = ref(sessionStorage.getItem("user") || "");

    const filteredMenus = computed(() => {
      const allMenus = [
        {
          name: "dashboard",
          title: t("nav.dashboard"),
          icon: homeIcon,
          path: "dashboard",
        },
        {
          name: "graph",
          title: "图形监控",
          icon: graphIcon,
          path: "graph",
          replace: true,
        },
        {
          name: "device",
          title: t("nav.device"),
          icon: deviceIcon,
          path: "device",
        },
        {
          name: "record",
          title: t("nav.record"),
          icon: alarmIcon,
          path: "record",
        },
        {
          name: "user",
          title: "用户管理",
          icon: userIcon,
          path: "user",
          roles: ["admin1"],
        },
        {
          name: "protocol",
          title: "报文监控",
          icon: protocolIcon,
          path: "protocol",
          roles: ["admin1"],
        },
      ];

      return allMenus.filter((menu) => {
        if (!menu.roles) return true;
        return menu.roles.includes(currentUser.value);
      });
    });

    const handleMenuClick = (menu) => {
      if (menu.replace) {
        router.replace({ name: menu.path });
      } else {
        router.push({ name: menu.path });
      }
    };

    watch(
      () => route.path,
      (newPath) => {
        currentUser.value = sessionStorage.getItem("user") || "";
        // 当从登录页面跳转到其他页面且已登录时，连接 Socket
        if (
          newPath !== "/login" &&
          sessionStorage.getItem("user") &&
          !store.state.socketClient
        ) {
          store.dispatch("subscribeData");
        }
      }
    );

    // 只在非登录页面时才连接 Socket
    // if (route.path !== '/login' && sessionStorage.getItem('user')) {
    //   store.dispatch("subscribeData");
    // }

    let timingWorker = null;
    let renderData = ref({});
    const weeks = [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六",
    ];

    async function getCurrentTime() {
      const { time } = await queryDbData({ tableId: "datetime" }); // 获取服务器时间
      renderData.value.systemTime = new Date(time).getTime();
      timingWorker = setInterval(() => {
        renderData.value.systemTime = new Date().getTime();
        let time = moment(renderData.value.systemTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        Object.assign(renderData.value, {
          weekday: weeks[moment(renderData.value.systemTime).day()],
          date: time?.split(" ")?.[0]?.replaceAll("-", "/") || "",
          time: time?.split(" ")?.[1] || "",
        });
      }, 1000);
    }

    async function handleLogout() {
      // 先断开 WebSocket 连接
      disconnectSocket();
      // 清除 store 中的 socket 客户端引用
      store.state.socketClient = null;
      // 调用退出登录接口
      await logout();
      sessionStorage.clear();
      router.replace({ name: "login" });
    }

    onBeforeMount(() => {
      // getCurrentTime();
    });

    onUnmounted(() => {
      if (timingWorker) clearInterval(timingWorker);
    });

    return {
      locale,
      route,
      router,
      renderData,
      handleLogout,
      t,
      currentUser,
      filteredMenus,
      handleMenuClick,
    };
  },
});
</script>

<style lang="less" scoped>
#root {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: auto;

  /*定义滚动条高宽及背景
 高宽分别对应横竖滚动条的尺寸*/
  &:deep(::-webkit-scrollbar) {
    width: 4px;
    height: 4px;
    border-radius: 2px;
  }

  /*定义滚动条轨道
 内阴影+圆角*/
  &:deep(::-webkit-scrollbar-track) {
    background: transparent;
  }

  /*定义滑块
 内阴影+圆角*/
  &:deep(::-webkit-scrollbar-thumb) {
    border-radius: 2px;
    background: #8afff7;
  }
}
.layout {
  color: #fff;
  background: url("~@/assets/images/page-bg.png") no-repeat center / 100% 100%;
  .header {
    height: 7.2rem;
    max-height: 7.2rem;
    background: url("~@/assets/images/header-bg.png") 0 0 no-repeat;
    background-size: 100% 100%;
    .left {
      width: 30%;
      padding-left: 2.5rem;
      // img {
      //   width: 2.5rem;
      //   height: 2.5rem;
      // }
      // i {
      //   font-size: 0.75rem;
      //   color: #d8d8d8;
      //   white-space: nowrap;
      //   margin-bottom: 5px;
      // }
      // span {
      //   font-size: 2rem;
      //   margin: 0 4px;
      //   line-height: 2.75rem;
      // }
      // em {
      //   font-size: 18px;
      //   line-height: 1.5rem;
      // }
      // div {
      //   padding: 0 8px;
      //   height: 1.125rem;
      //   font-size: 0.75rem;
      //   color: #181818;
      //   white-space: nowrap;
      //   margin-left: 5px;
      //   border-radius: 0.5rem;
      //   background: linear-gradient(270deg, #336de7 0%, #29cbe8 100%);
      // }
      .arrow {
        color: #00baad !important;
        font-size: 2.25rem !important;
      }
    }
    .mid {
      // margin-top: 2.5rem;
      > img {
        width: 31rem;
      }
      .head-text {
        text-align: center;
        font-size: 2rem;
        background: linear-gradient(to bottom, #b6ffd1, #139e95);
        color: transparent;
        -webkit-background-clip: text;
        font-family: SF Pro SC, SF Pro Display, SF Pro Icons, PingFang SC,
          Helvetica Neue, Helvetica, Arial, sans-serif;
        .fr {
          font-size: 0.2rem;
        }
      }
    }
    .right {
      width: 30%;
      img {
        width: 2rem;
        height: 2rem;
        margin-bottom: 5px;
        cursor: pointer;
      }
      > span {
        font-size: 0.875rem;
        font-weight: 500;
        color: #2ed6db;
        white-space: nowrap;
        &:nth-child(2) {
          font-size: 1.5rem;
          color: #d8d8d8;
        }
      }
    }
  }
  .container {
    height: 100%;
    padding: 1rem;
  }
}
</style>
